webpackJsonp([28],{

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: 'error__wrapper' },
    _react2.default.createElement(
      'h1',
      null,
      '404'
    ),
    _react2.default.createElement(
      'h2',
      null,
      'Page Not Found'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Looks like the page you are looking for is missing :('
    )
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/404.090bf4d5.js